import React from 'react'
import ListPeriodsheader from './ListPeriodsTable/ListPeriodsheader'
import ListPeriodsRow from './ListPeriodsTable/ListPeriodsRow'

function ListPeriodsTable(props) {
    const {listPeriods, loading, setType} = props

    return (
        <div className='ListPeriodsTable'>
            <table className="table table-borderless table-striped">
                <ListPeriodsheader />
                <tbody className="ListPeriodsRow">
                    {
                        !!listPeriods && listPeriods.length > 0 && listPeriods.map((item, i) => {
                            return <ListPeriodsRow
                                key={i}
                                index={i}
                                item={item}
                                setType={setType}
                            />
                        })
                    }
                    {
                        !loading && (!listPeriods || listPeriods.length === 0) &&
                        <tr>
                            <td colSpan={6}>
                                No result
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    )
}

export default ListPeriodsTable